import {
  useAppStore,
  useHandleClickCreateNewSetList,
  useHandleClickCreateNewSong,
} from "@/store/app";
import type { MouseEventHandler } from "react";
import { MdAdd } from "react-icons/md";

export default function Fabs() {
  const selectedTab = useAppStore(({ selectedTab }) => selectedTab);
  const handleClickCreateNewSong = useHandleClickCreateNewSong();
  const handleClickCreateNewSetList = useHandleClickCreateNewSetList();

  if (!["songlist", "setlists"].includes(selectedTab)) return <></>;

  return (
    <div
      className="btn btn-circle btn-ghost shadow-lg bg-primary hover:bg-primary-focus text-2xl fixed z-[1] text-white bottom-4 right-4 sm:left-[320px] sm:right-auto"
      onClick={
        selectedTab === "songlist"
          ? (handleClickCreateNewSong as MouseEventHandler)
          : (handleClickCreateNewSetList as MouseEventHandler)
      }
    >
      <MdAdd />
    </div>
  );
}
